export default __webpack_public_path__ + "static/media/Reports.DataTable.9b2feaca.svg";